import FreeDeliveryIcon from 'components/icons/free-delivery';

const FreeDelivery = () => {
  return (
    <div className="m-0 border-0 p-0 pt-12 align-baseline md:pt-0">
      <div className="content-asset">
        <div className="relative mb-18 box-border rounded bg-[#ecf6f1] pb-18 sm:h-full">
          <div className="border-opacity/30 absolute right-[48px] top-[-10px] box-content h-18 w-18 rotate-45 border-l border-t border-solid border-gray-200 bg-[#ecf6f1]">
            <div className="h-18">&nbsp;</div>
          </div>
          <div className="absolute">
            <FreeDeliveryIcon></FreeDeliveryIcon>
          </div>
          <div className="p-18 text-center">
            {/* <p className="mb-18 font-bold">Congratulations,</p> */}
            <p className="font-bold">Congratulations,</p>
            <p className="text-sm font-light capitalize">
              You qualify for <span className="text-base font-bold uppercase text-green-500">free delivery</span>
            </p>
          </div>
          <div className="bg-free-delivery-gradient-custom mx-auto max-h-[10px] max-w-[254px] rounded-[20px]">
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeDelivery;
